// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9d20c140","832":"32d51340","884":"a9330997"}[chunkId] + ".chunk.js";
};